import DatePicker from './el-date-picker.vue'
import Tabs from './tabs.vue'
import Captcha from './captcha.vue'
import CardHeader from './card-header.vue'
import CardRecordHeader from './card-header-records.vue'
import Video from './video.vue'
import Table from './table.vue'
import Dialog from './dialog.vue'
import CreateAccount from './create-account.vue'
import BankSelect from './bank-select.vue'
import ThreeList from './three-list.vue'
import AmountInput from './amount-input.vue'
import TabsRouter from './tabs-router.vue'
import PreviewDialog from './preview-dialog.vue'
import CancelDialog from './cancel-dialog.vue'
import BankAccount from './bank-acc-select'
import AccountNumberSelect from './account-number/account-number.vue'
import AccountNumbersSelect from './account-number/account-withdrawal-number.vue'
import Upload from './upload/index'
import DepositType from './deposit-type'
import EddidBankAccount from './eddid-bank-account'
import EddidBankAccountDetail from './eddid-bank-account-detail'
import PreviewBankNum from './previewBankNum'
import AccountInfo from './account-info'
import Loading from './loading'
import MobileShowPhone from './mobileShowPhone'
import UploadImage from './uploadImage'

export default {
  Video,
  AccountNumbersSelect,
  CardRecordHeader,
  AccountNumberSelect,
  DatePicker,
  PreviewDialog,
  TabsRouter,
  AmountInput,
  CancelDialog,
  Captcha,
  Upload,
  CardHeader,
  Table,
  Tabs,
  Dialog,
  ThreeList,
  Loading,
  CreateAccount,
  BankSelect,
  BankAccount,
  DepositType,
  EddidBankAccount,
  EddidBankAccountDetail,
  PreviewBankNum,
  AccountInfo,
  MobileShowPhone,
  UploadImage
}
